import { FaCalendarDays, FaComments, FaClipboardList } from "react-icons/fa6";

const About = {
    sub: "About Us",
    heading: "Your Gateway to Networking and Learning",
    description: "Welcome to MeetupSphere, your premier platform for connecting with professionals and enthusiasts in various fields. We specialize in organizing engaging meetups that foster networking, collaboration, and knowledge sharing. Join us for insightful discussions and innovative ideas that can propel your career and projects forward.",
    points: [
        { icon: <FaCalendarDays />, title: "Networking Opportunities" },
        { icon: <FaComments />, title: "Expert Speakers" },
        { icon: <FaCalendarDays />, title: "Regular Meetups" },
        { icon: <FaClipboardList />, title: "Resource Sharing" }
    ],
    button: {
        text: "Join Us",
        link: "Registration"
    }
};

export default About;